module.exports = __webpack_public_path__ + "img/El Salvador.9b1059f6.gif";